import React, { forwardRef, ImgHTMLAttributes } from 'react';
import { useImageSrc } from '../../hooks/useImageSrc';
import { Image } from '../image/Image';

export const AssetImage = forwardRef<HTMLImageElement, Props>(({
    alt = '', crossOrigin = 'anonymous', src,
    ...props
}, ref) => (
    <Image crossOrigin={crossOrigin} loading='lazy' src={useImageSrc(src)} alt={alt} ref={ref} {...props} />
));

type Props = ImgHTMLAttributes<HTMLImageElement>;